import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Typography } from 'antd';

const ScreenShareView = () => {
  const { meetingSession, videoTiles } = useSelector(state => state.interviewRecording);
  const screenShareRef = useRef(null);
  const [contentTileId, setContentTileId] = useState(null);

  // Bind/unbind content share whenever contentTileId changes
  useEffect(() => {
    if (!meetingSession || !meetingSession.audioVideo) return;
    const audioVideo = meetingSession.audioVideo;

    console.log('Reference', screenShareRef);
    if (contentTileId && screenShareRef.current) {
      audioVideo.bindVideoElement(contentTileId, screenShareRef.current);
    }

    return () => {
      if (contentTileId && meetingSession.audioVideo) {
        meetingSession.audioVideo.unbindVideoElement(contentTileId);
      }
    };
  }, [contentTileId, meetingSession]);

  // Observe video tiles for content share updates
  useEffect(() => {
    if (!meetingSession || !meetingSession.audioVideo) return;
    const audioVideo = meetingSession.audioVideo;

    const observer = {
      videoTileDidUpdate: tileState => {
        if (tileState.isContent) {
          setContentTileId(tileState.tileId);
        }
      },
      videoTileWasRemoved: tileId => {
        if (tileId === contentTileId) {
          setContentTileId(null);
        }
      },
    };

    audioVideo.addObserver(observer);

    // Bind to existing content tile if joining mid-session
    const existingContent = Array.from(videoTiles?.values() || []).find(tile => tile.isContent);
    if (existingContent) {
      setContentTileId(existingContent.tileId);
    }

    return () => {
      audioVideo.removeObserver(observer);
    };
  }, [meetingSession, videoTiles, contentTileId]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Card
        style={{
          width: '100%',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          marginBottom: '20px',
        }}
        bodyStyle={{ padding: '24px' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <div
            style={{
              width: '100%',
              backgroundColor: '#000',
              borderRadius: '8px',
              overflow: 'hidden',
              position: 'relative',
              aspectRatio: '16/9',
              maxHeight: '70vh',
            }}
          >
            {/* Always render the video element */}
            <video
              ref={screenShareRef}
              style={{
                width: '100%',
                height: '100%',
                objectFit: contentTileId ? 'contain' : 'cover',
                display: 'block',
                backgroundColor: '#000',
              }}
              autoPlay
              playsInline
            />
            {!contentTileId && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontSize: 16,
                  backgroundColor: 'rgba(0,0,0,0.8)',
                }}
              >
                No screen sharing in progress
              </div>
            )}

            {contentTileId && (
              <div
                style={{
                  position: 'absolute',
                  top: 12,
                  left: 12,
                  background: 'rgba(0,0,0,0.8)',
                  color: '#fff',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '500',
                }}
              >
                🔴 Live Screen Share
              </div>
            )}
          </div>

          <Typography.Text
            type="secondary"
            style={{ fontSize: '13px', textAlign: 'center' }}
          >
            The candidate is sharing their screen. You can see their desktop or application in
            real-time.
          </Typography.Text>
        </div>
      </Card>
    </div>
  );
};

export default ScreenShareView;
